import * as React from 'react'

import { XIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  index?: number
  onClick(index?: number): void
}

@observer
export default class PermitFieldRemoveIcon extends React.Component<IProps> {
  public render() {
    return (
      <div className="pl5 no-grow tw:flex">
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={Localization.translator.remove}
          className="tw:text-muted-foreground"
          onMouseDown={e => e.preventDefault()}
          onClick={this.onRemoveClick}
        >
          <XIcon />
        </Button>
      </div>
    )
  }

  private onRemoveClick = () => {
    const { index, onClick } = this.props
    onClick(index)
  }
}
